import React, { useId } from "react";
import { offer } from "../data/offer";
type PurchaseButtonProps = {
  label: string;
  className?: string;
};

// Bouton d'achat : actif uniquement lorsque offer.checkoutUrl est renseigné.
export function PurchaseButton({
  label,
  className = ""
}: PurchaseButtonProps) {
  const noteId = useId();
  const isReady = offer.checkoutUrl.trim().length > 0;
  const content = <span className="flex flex-col items-center leading-tight sm:flex-row sm:gap-2" data-id="element-154" data-mp="qq8unszl1q10">
      <span data-id="element-155" data-mp="vp27rkayjf0n">{label}</span>
      <span className="hidden sm:inline" aria-hidden="true" data-id="element-156" data-mp="vplhweud8z44">
        —
      </span>
      <span data-id="element-157" data-mp="hxx2o2otluix">{offer.price}</span>
    </span>;
  const base = "flex w-full items-center justify-center whitespace-nowrap rounded-full px-6 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white md:py-5 md:text-base";
  if (isReady) {
    return <a href={offer.checkoutUrl} className={`${base} bg-terracotta transition-[background-color,transform] duration-150 ease-out hover:bg-terracotta-dark active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terracotta ${className}`} data-id="element-158" data-mp="19mqgjtrr2vpc">
        {content}
      </a>;
  }
  return <div className={className} data-id="element-159" data-mp="11nqwgx49roby">
      <button type="button" disabled aria-describedby={noteId} className={`${base} cursor-not-allowed bg-terracotta/55`} data-id="element-160" data-mp="11os9360xoivs">
        {content}
      </button>
      <p id={noteId} className="mt-2 text-center text-xs text-ink-soft" data-id="element-161" data-mp="1apqdhpfaasew">
        Les commandes ouvriront très prochainement.
      </p>
    </div>;
}